import Typography from '../components/Typography';
import Layout from '../components/Layout';
import { useNavigate } from '@reach/router';

const RadioButton = ({ icon, title, description }) => {
  return (
    <div className="bg-[#E8E4F9] rounded-[16px] border-2 border-solid border-[#1A237E] p-5 flex gap-x-4">
      <div className="p-3 rounded-[16px] bg-white h-12 w-12">{icon}</div>
      <div>
        <Typography weight="bold" className="text-[18px]" lineHeight="normal">
          {title}
        </Typography>
        <Typography
          color="secondary"
          className="text-[14px]"
          lineHeight="normal"
        >
          {description}
        </Typography>
      </div>
    </div>
  );
};

const AddMessage = () => {
  const navigate = useNavigate();
  return (
    <Layout className="pt-20 px-6">
      <Typography className="text-[14px] mb-9" weight="bold">
        MAKE IT PERSONAL
      </Typography>
      <div className="flex flex-col gap-y-4 mb-24">
        <RadioButton
          title="Record a video"
          description="30 sec max – say something nice"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M17.0156 10.5V6.98438C17.0156 6.46875 16.5469 6 15.9844 6H3.98438C3.46875 6 3 6.46875 3 6.98438V17.0156C3 17.5312 3.46875 18 3.98438 18H15.9844C16.5469 18 17.0156 17.5312 17.0156 17.0156V13.5L19.3125 15.7969C19.9219 16.4062 21 15.9844 21 15.0938V8.90625C21 8.01562 19.9219 7.54688 19.3125 8.20312L17.0156 10.5Z"
                fill="#1A237E"
              />
            </svg>
          }
        />
        <RadioButton
          title="Upload a video"
          description="From your camera roll"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M20.0156 6H12L10.5938 4.59375C10.2188 4.21875 9.70312 3.98438 9.1875 3.98438H3.98438C2.90625 3.98438 2.01562 4.92188 2.01562 6V18C2.01562 19.0781 2.90625 20.0156 3.98438 20.0156H20.0156C21.0938 20.0156 21.9844 19.0781 21.9844 18V8.01562C21.9844 6.89062 21.0938 6 20.0156 6ZM18.9844 18H5.01562C4.45312 18 3.98438 17.5312 3.98438 17.0156V9C3.98438 8.4375 4.45312 8.01562 5.01562 8.01562H18.9844C19.5469 8.01562 20.0156 8.4375 20.0156 9V17.0156C20.0156 17.5312 19.5469 18 18.9844 18Z"
                fill="#1A237E"
              />
            </svg>
          }
        />
        <RadioButton
          title="Write a note"
          description="Keep it simple"
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M0 14.4375V17.4844C0 17.7656 0.234375 18 0.515625 18H3.5625C3.65625 18 3.79688 17.9531 3.89062 17.8594L14.8125 6.9375L11.0625 3.1875L0.140625 14.1094C0.046875 14.2031 0 14.2969 0 14.4375ZM17.7188 4.03125C18.0938 3.65625 18.0938 3 17.7188 2.625L15.375 0.28125C15 -0.09375 14.3438 -0.09375 13.9688 0.28125L12.1406 2.10938L15.8906 5.85938L17.7188 4.03125Z"
                fill="#1A237E"
              />
            </svg>
          }
        />
      </div>
      <button
        className="cz-btn-brand w-full mb-6"
        onClick={() => navigate(`/gift-redeem/video`)}
      >
        Add Message
      </button>
      <button className="bg-white w-full border-none cursor-pointer py-2">
        <Typography className="text-[14px]" color="secondary">
          Skip for now
        </Typography>
      </button>
    </Layout>
  );
};

export default AddMessage;
